import { getVariationGroupId } from '../../../common/helpers/productIdHelpers';

function getSelectedComplementProductsTotalPrice(complements) {
  return complements.reduce(
    (total, complement) => total + ((complement.price || 0) * complement.qty), 0,
  );
}

export const types = {
  isRemovingComplement: 'productCustomizer/isRemovingComplement',
  load: 'productCustomizer/load',
  loading: 'productCustomizer/loading',
  lockRemove: 'productCustomizer/lockRemove',
  updateComplementProduct: 'productCustomizer/updateComplementProduct',
  removeComplementProduct: 'productCustomizer/removeComplementProduct',
  removeUIComplementProduct: 'productCustomizer/removeUIComplementProduct',
  resetCustomizer: 'productCustomizer/resetCustomizer',
  selectMainProduct: 'productCustomizer/selectMainProduct',
};

export const getters = {
  complementProducts: 'productCustomizer/complementProducts',
  mainProducts: 'productCustomizer/mainProducts',
  customizerId: 'productCustomizer/customizerId',
  selectedComplementProducts: 'productCustomizer/selectedComplementProducts',
  selectedMainProduct: 'productCustomizer/selectedMainProduct',
  totalPrice: 'productCustomizer/totalPrice',
  uiComplementProducts: 'productCustomizer/uiComplementProducts',
  uiMainProduct: 'productCustomizer/uiMainProduct',
};

export default {
  namespaced: true,
  state: {
    isRemovingComplement: false,
    loading: false,
    lockRemove: false,
    productSet: {
      individualProducts: [],
    },
    selectedProducts: {
      main: null,
      complements: [],
    },
    ui: {
      main: null,
      complements: [],
    },
  },
  getters: {
    complementProducts: (state) => state.productSet.individualProducts.filter((product) => product.productType === 'set'),
    mainProducts: (state) => state.productSet.individualProducts.filter((product) => product.productType !== 'set'),
    customizerId: (state) => state.productSet.id,
    selectedComplementProducts: (state) => state.selectedProducts.complements,
    selectedMainProduct: (state) => state.selectedProducts.main,
    totalPrice: (state) => (state.selectedProducts.main?.price || 0)
      + getSelectedComplementProductsTotalPrice(state.selectedProducts.complements),
    uiComplementProducts: (state) => state.ui.complements,
    uiMainProduct: (state) => state.ui.main,
  },
  mutations: {
    isRemovingComplement(state, isRemovingComplement = true) {
      state.isRemovingComplement = isRemovingComplement;
    },
    loading(state, loading = true) {
      state.loading = loading;
    },
    lockRemove(state, lockRemove = true) {
      state.lockRemove = lockRemove;
    },
    setProductSet(state, productSet) {
      state.productSet = productSet;
    },
    setSelectedComplementProducts(state, selectedComplements) {
      state.selectedProducts.complements = selectedComplements;
    },
    setSelectedMainProduct(state, mainProduct) {
      state.selectedProducts.main = mainProduct;
    },
    setUIMainProduct(state, mainProduct) {
      state.ui.main = mainProduct;
    },
    setUIComplementProducts(state, complementProducts) {
      state.ui.complements = complementProducts;
    },
  },
  actions: {
    load({ commit }, productSet) {
      commit('loading');
      commit('setProductSet', productSet);
      commit('loading', false);
    },
    // eslint-disable-next-line no-shadow
    removeComplementProduct({ commit, getters }, productId) {
      const selectedComplements = getters.selectedComplementProducts;
      const filteredSelectedComplements = selectedComplements.filter(
        (complement) => getVariationGroupId(complement.pid) !== productId,
      );
      commit('setSelectedComplementProducts', filteredSelectedComplements);
      commit('lockRemove', false);
    },
    // eslint-disable-next-line no-shadow
    removeUIComplementProduct({ commit, getters }, { productId, index }) {
      const complementUIProducts = getters.uiComplementProducts;
      const filteredComplementProducts = complementUIProducts.filter(
        (product, i) => !(i === index && product === productId),
      );
      commit('setUIComplementProducts', filteredComplementProducts);
    },
    resetCustomizer({ commit }) {
      commit('setUIComplementProducts', []);
      commit('setSelectedComplementProducts', []);
    },
    selectMainProduct({ commit }, mainProduct) {
      commit('setSelectedMainProduct', mainProduct);
      commit('setUIMainProduct', getVariationGroupId(mainProduct.pid));
    },
    // eslint-disable-next-line no-shadow
    updateComplementProduct({ commit, getters }, product) {
      const selectedComplements = getters.selectedComplementProducts;
      const currentComplement = selectedComplements.find(
        (complement) => getVariationGroupId(complement.pid) === getVariationGroupId(product.pid),
      );
      let addUI = false;
      if (currentComplement) {
        addUI = product.qty > currentComplement.qty;
        currentComplement.qty = product.qty;
      } else {
        selectedComplements.push(product);
        addUI = true;
      }
      if (addUI) {
        const complementUIProducts = getters.uiComplementProducts;
        complementUIProducts.push(getVariationGroupId(product.pid));
        commit('setUIComplementProducts', complementUIProducts);
        commit('isRemovingComplement', false);
      } else {
        commit('lockRemove', false);
      }
      commit('setSelectedComplementProducts', selectedComplements);
    },
  },
};
